function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpectrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.987 511.987",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 66.717,
    y: 204.027,
    transform: "matrix(-0.2411 -0.9705 0.9705 -0.2411 -177.6681 420.4137)",
    style: {
      fill: "#B6F2FC"
    },
    width: 17.648,
    height: 151.29
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8ED7E0"
    },
    points: "235.67,98.502 417.524,413.484 53.815,413.484 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4BD64"
    },
    points: "511.987,268.44 511.987,315.737 368.184,337.491 344.872,329.255 296.635,235.133 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4EB79B"
    },
    points: "511.987,315.737 511.987,363.022 384.886,356.939 384.874,356.939 344.872,329.255  356.814,308.325 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E88158"
    },
    points: "511.987,221.156 511.987,268.44 328.73,259.687 276.634,248.075 300.658,211.061 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B6F2FC"
    },
    points: "384.874,356.939 385.874,358.669 113.88,263.558 300.658,211.061 328.73,259.687  356.802,308.325 356.814,308.325 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpectrum);
export default __webpack_public_path__ + "static/media/spectrum.d3fd99df22d3a534a5681b8c99fbf37f.svg";
export { ForwardRef as ReactComponent };